import type { JSX } from 'react';
import aosphereLogoSingleTheme from '../assets/aosphere-logo-single-theme.svg';
import aosphereLogoWhite from '../assets/images/error/aoslogin-experts-logo-white.svg';
import { useIsSingleTheme } from '../theme/useIsSingleTheme';

/**
 * Centered brand lockup for the full-page error/not-found screens — the aosphere
 * wordmark, white-on-transparent for the dark map-gradient background.
 *
 * Single-theme mode (`single-theme-release` via the V3 shell) swaps in the
 * RegSource wordmark + tagline, matching  nextgenui-user.
 */
export function BrandLockup(): JSX.Element {
  const singleTheme = useIsSingleTheme();

  return (
    <div className="d-flex align-items-center justify-content-center w-100">
      <img
        alt="aosphere"
        src={singleTheme ? aosphereLogoSingleTheme : aosphereLogoWhite}
        style={{ height: 'auto', width: '100%', maxWidth: 420 }}
      />
    </div>
  );
}
